/* INTEGY V577 — filtered-product reliability guard.
   V647/V42 taxonomy is the current compatibility candidate source for compatibility, while Shopify product JSON
   is the live authority for stock. Rare facet choices are verified live before V576
   hides them; stale cached availability can no longer suppress a valid choice alone. */
(function(){
 'use strict';
 var root=document.documentElement;
 function v626Root(){try{var r=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root;if(r)return r.charAt(r.length-1)==='/'?r:r+'/'}catch(e){}return'/'}
 function v626Path(p){return v626Root()+String(p||'').replace(/^\/+/, '')}
 var LIVE_FACET_MAX_CANDIDATES=6;
 var LIVE_FACET_MAX_FETCHES=36;
 var liveFacetFetches=0;
 var liveStockCache=Object.create(null);
 function handleize(v){
   v=String(v||'').toLowerCase();
   try{v=v.normalize('NFKD').replace(/[\u0300-\u036f]/g,'')}catch(e){}
   return v.replace(/&/g,'-').replace(/['\u2019]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
 }
 function safeProductUrl(value){
   value=String(value||'');
   if(value.indexOf('/products/')<0)return value;
   try{
     var u=new URL(value,location.origin),m=u.pathname.match(/\/products\/([^/]+)(.*)$/i);
     if(!m)return value;
     var h=handleize(decodeURIComponent(m[1]));
     if(!h)return value;
     u.pathname=v626Path('products/'+h+(m[2]||''));
     return u.origin===location.origin?u.pathname+u.search+u.hash:u.href;
   }catch(e){return value}
 }
 function normalizeNode(scope){
   var nodes=[];
   if(scope&&scope.nodeType===1)nodes.push(scope);
   if(scope&&scope.querySelectorAll)nodes=nodes.concat(Array.prototype.slice.call(scope.querySelectorAll('a[href*="/products/"],[data-integy-v426-product-url],[data-integy-v528-price-url],[data-product-url],[data-product-href]')));
   nodes.forEach(function(n){
     if(n.matches&&n.matches('a[href*="/products/"]')){var h=n.getAttribute('href')||'';var sh=safeProductUrl(h);if(sh!==h)n.setAttribute('href',sh)}
     ['data-integy-v426-product-url','data-integy-v528-price-url','data-product-url','data-product-href'].forEach(function(a){if(!n.hasAttribute||!n.hasAttribute(a))return;var v=n.getAttribute(a)||'';var sv=safeProductUrl(v);if(sv!==v)n.setAttribute(a,sv)});
   });
 }
 function imageFallback(img){
   if(!img||img.nodeName!=='IMG'||img.getAttribute('data-integy-v576-image-fallback')==='true')return;
   var card=img.closest&&img.closest('[data-product-item],.productgrid--item,.productitem');
   if(!card)return;
   img.setAttribute('data-integy-v576-image-fallback','true');
   img.hidden=true;
   var holder=img.closest('figure,.productitem--image,[data-product-item-image]')||img.parentNode;
   if(holder&&!holder.querySelector('.integy-v576-image-placeholder')){
     var p=document.createElement('span');p.className='integy-v576-image-placeholder';p.setAttribute('role','img');p.setAttribute('aria-label','Product image unavailable');p.textContent='Image unavailable';holder.appendChild(p);
   }
   card.classList.add('integy-v576-missing-image');
 }
 function scanImages(scope){
   var imgs=[];if(scope&&scope.nodeName==='IMG')imgs.push(scope);if(scope&&scope.querySelectorAll)imgs=imgs.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-product-item] img,.productgrid--item img,.productitem img')));
   imgs.forEach(function(img){if(img.complete&&img.naturalWidth===0)imageFallback(img)});
 }
 function zeroGuard(scope){
   var rows=[];if(scope&&scope.matches&&scope.matches('[data-integy-v307-option]'))rows.push(scope);if(scope&&scope.querySelectorAll)rows=rows.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-integy-v307-option]')));
   rows.forEach(function(row){var c=Number(row.getAttribute('data-integy-v307-count'));var active=row.getAttribute('aria-pressed')==='true'||row.classList.contains('is-active');if(!active&&isFinite(c)&&c<=0&&row.getAttribute('data-integy-v576-stock-provisional')!=='true'){row.hidden=true;row.setAttribute('aria-disabled','true');row.tabIndex=-1}});
 }
 var facetIndexPromise=null;
 function collectionHandle(pathname){var m=String(pathname||location.pathname).match(/\/collections\/([^/?#]+)/i);return m?handleize(decodeURIComponent(m[1])):''}
 function healFacetMetadata(index){
   if(!index||!index.collections)return index;
   Object.keys(index.collections).forEach(function(k){var d=index.collections[k]||{},b=d.buckets||{},c={},a=[];Object.keys(b).forEach(function(h){var v=Array.isArray(b[h])?b[h]:[];if(v.length){c[h]=v.length;a.push(h)}});d.counts=c;d.available_handles=a});
   return index;
 }
 function facetIndex(){
   var owner=window.IntegyV501FilterOwner;
   return owner&&typeof owner.getIndex==='function'?owner.getIndex():Promise.resolve(null);
 }
 function scopedData(index,h){if(!index||!h)return null;var k=index.collections&&index.collections[h]?h:(index.collection_aliases&&index.collection_aliases[h]||'');return k&&index.collections&&index.collections[k]?index.collections[k]:null}
 function targetTags(anchor){try{var u=new URL(anchor.getAttribute('href')||anchor.href,location.origin);if(collectionHandle(u.pathname)!==collectionHandle())return null;var raw=u.searchParams.get('integy_filter')||u.searchParams.get('integy_filters')||u.searchParams.get('integy_tag_filter')||'';return raw.split('+').map(handleize).filter(Boolean)}catch(e){return null}}
 function recordForSku(index,sku){
   var products=index&&index.products||{},key=String(sku||'');
   if(products[key])return products[key];
   var lk=key.toLowerCase(),keys=Object.keys(products);
   for(var i=0;i<keys.length;i++)if(keys[i].toLowerCase()===lk)return products[keys[i]];
   return null;
 }
 function candidateRecords(index,data,tags){
   if(!data)return[];
   var base=(data.products||[]).slice(),aliases=index.aliases||{};
   if(tags&&tags.length){
     var sets=[];
     for(var i=0;i<tags.length;i++){
       var t=aliases[tags[i]]||tags[i],vals=data.buckets&&data.buckets[t];
       if(!vals)return[];
       var set=Object.create(null);vals.forEach(function(s){set[String(s).toLowerCase()]=1});sets.push(set);
     }
     base=base.filter(function(s){var k=String(s).toLowerCase();return sets.every(function(set){return!!set[k]})});
   }
   return base.map(function(s){return recordForSku(index,s)}).filter(Boolean);
 }
 function stockMode(){
   try{var q=new URLSearchParams(location.search||'');if(q.get('filter.v.availability')==='0'||q.get('integy_stock')==='out')return'out';if(q.get('integy_stock')==='all')return'all'}catch(e){}
   return'in';
 }
 function liveEndpoint(record){
   try{var u=new URL(record&&record.url||'',location.origin),m=u.pathname.match(/\/products\/([^/?#]+)/i);return m?v626Path('products/'+handleize(decodeURIComponent(m[1]))+'.js'):''}catch(e){return''}
 }
 function liveAvailable(record){
   var endpoint=liveEndpoint(record);
   if(!endpoint)return Promise.resolve(null);
   if(liveStockCache[endpoint])return liveStockCache[endpoint];
   if(liveFacetFetches>=LIVE_FACET_MAX_FETCHES)return Promise.resolve(null);
   liveFacetFetches+=1;
   liveStockCache[endpoint]=fetch(endpoint,{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw new Error('stock');return r.json()}).then(function(product){var variants=product&&Array.isArray(product.variants)?product.variants:[];return variants.some(function(v){return!!(v&&v.available)})}).catch(function(){return null});
   return liveStockCache[endpoint];
 }
 function cachedStockCount(records,mode){
   var count=0;
   (records||[]).forEach(function(r){var a=!r||r.available!==false;if(mode==='out'?!a:a)count+=1});
   return count;
 }
 function setAttr(a,n,v){v=String(v);if(a.getAttribute(n)!==v)a.setAttribute(n,v)}
 function setManagedVisibility(a,count,active,verified){
   setAttr(a,'data-integy-v576-stock-facet-count',count);
   if(verified)setAttr(a,'data-integy-v576-stock-live-verified','true');
   if(!active&&verified&&count<=0){
     a.hidden=true;a.style.display='none';a.setAttribute('aria-disabled','true');a.tabIndex=-1;a.setAttribute('data-integy-v576-stock-hidden','true');
   }else if(a.getAttribute('data-integy-v576-stock-hidden')==='true'){
     a.hidden=false;a.style.display='';a.removeAttribute('aria-disabled');a.removeAttribute('data-integy-v576-stock-hidden');a.removeAttribute('tabindex');
   }
   if(count>0||active){setAttr(a,'data-integy-v307-count',count);var c=a.querySelector&&a.querySelector('[data-filtered-product-count],.filtered-product-count');if(c){c.textContent='('+count+')';c.classList.remove('filtered-product-count--hidden')}}
 }
 function verifySmallFacet(a,records,mode,active){
   if(mode==='all'||!records.length||records.length>LIVE_FACET_MAX_CANDIDATES)return;
   var endpoints=records.map(liveEndpoint).filter(Boolean);
   if(!endpoints.length)return;
   var unique=Object.create(null),needed=0;endpoints.forEach(function(e){if(!unique[e]){unique[e]=1;if(!liveStockCache[e])needed+=1}});
   if(liveFacetFetches+needed>LIVE_FACET_MAX_FETCHES)return;
   Promise.all(records.map(liveAvailable)).then(function(values){
     if(!a.isConnected)return;
     if(values.some(function(v){return v===null}))return; // conservative on network failure
     var count=values.filter(function(v){return mode==='out'?!v:v}).length;
     a.removeAttribute('data-integy-v576-stock-provisional');
     setManagedVisibility(a,count,active,true);
   });
 }
 function stockAwareFacetGuard(){
   var h=collectionHandle();if(!h)return;
   facetIndex().then(function(index){
     var data=scopedData(index,h);if(!data)return;
     var mode=stockMode();
     var links=Array.prototype.slice.call(document.querySelectorAll('.productgrid--sidebar a[href*="integy_filter="],[data-productgrid-sidebar] a[href*="integy_filter="],[data-integy-v520-model-list] a[href*="integy_filter="],a[data-integy-v307-option][href]'));
     links.forEach(function(a){
       var tags=targetTags(a);if(tags===null)return;
       var records=candidateRecords(index,data,tags),active=a.getAttribute('aria-pressed')==='true'||a.classList.contains('is-active');
       if(mode==='all'){setManagedVisibility(a,records.length,active,false);return}
       var cached=cachedStockCount(records,mode);
       // Never hide from cached availability alone. A cached zero stays visible/provisional.
       var provisional=cached>0?cached:records.length;
       a.setAttribute('data-integy-v576-stock-provisional','true');
       setManagedVisibility(a,provisional,active,false);
       verifySmallFacet(a,records,mode,active);
     });
   });
 }
 var stockGuardTimer=0;
 function scheduleStockGuard(){clearTimeout(stockGuardTimer);stockGuardTimer=setTimeout(stockAwareFacetGuard,80)}
 function sweep(scope){normalizeNode(scope||document);scanImages(scope||document);zeroGuard(scope||document);scheduleStockGuard();root.classList.add('integy-v576-reliability-ready')}
 document.addEventListener('error',function(e){if(e.target&&e.target.nodeName==='IMG')imageFallback(e.target)},true);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){sweep(document)},{once:true});else sweep(document);
 if(window.MutationObserver){var t=0;new MutationObserver(function(ms){clearTimeout(t);t=setTimeout(function(){ms.forEach(function(m){Array.prototype.forEach.call(m.addedNodes||[],function(n){if(n.nodeType===1)sweep(n)})});zeroGuard(document);scheduleStockGuard()},60)}).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['data-integy-v307-count']})}
})();
